/* ============================================================
   I'M A NATURAL — keep the theme's sticky add-to-cart bar clear of the
   Shopify Forms newsletter pop-up (see assets/ian-popups.css, section 3).

   The Forms pop-up lives in a shadow root and is positioned by the app,
   so it can't be moved from the theme. This only *measures* it: whenever
   it's on screen as a corner widget (teaser or opened form) it publishes
   its right edge and height on <html>, and the CSS places the sticky bar
   beside / above it. Nothing in the pop-up is changed, and on pages
   without the sticky bar (anything but a product page) it does nothing.
   ============================================================ */
function ianPopupsInit() {
  if (!document.querySelector('.product__viewbar')) return;

  var root = document.documentElement;
  var pending = false;

  function popupBox(host) {
    var sr = host && host.shadowRoot;
    var embed = sr && sr.querySelector('#app-embed');
    if (!embed) return null;
    // The visible card is the embed's content, not the (padded) wrapper.
    var best = null;
    embed.querySelectorAll('*').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 40 || r.height < 30) return;
      var s = getComputedStyle(el);
      if (s.visibility === 'hidden' || s.display === 'none' || parseFloat(s.opacity) === 0) return;
      if (!best) { best = { left: r.left, top: r.top, right: r.right, bottom: r.bottom }; return; }
      best.left = Math.min(best.left, r.left);
      best.top = Math.min(best.top, r.top);
      best.right = Math.max(best.right, r.right);
      best.bottom = Math.max(best.bottom, r.bottom);
    });
    return best;
  }

  function update() {
    pending = false;
    var box = popupBox(document.querySelector('shopify-forms-embed'));
    var vw = window.innerWidth, vh = window.innerHeight;
    // Treat it as a corner widget only if it's actually in the lower-left
    // area; a centred full-screen popup has its own overlay and needs no
    // help.
    var corner = box && box.right > 0 && box.bottom > 0 && box.right < vw * 0.7 && box.left < vw * 0.3;
    if (corner) {
      root.classList.add('ian-forms-popup-visible');
      root.style.setProperty('--ian-forms-popup-right', Math.ceil(box.right) + 'px');
      root.style.setProperty('--ian-forms-popup-rise', Math.ceil(vh - box.top) + 'px');
    } else {
      root.classList.remove('ian-forms-popup-visible');
      root.style.removeProperty('--ian-forms-popup-right');
      root.style.removeProperty('--ian-forms-popup-rise');
    }
  }

  // Batched to the next frame, with a timer fallback for when frames
  // aren't being produced (background tabs pause requestAnimationFrame).
  function schedule() {
    if (pending) return;
    pending = true;
    var done = false;
    function run() { if (done) return; done = true; update(); }
    requestAnimationFrame(run);
    setTimeout(run, 120);
  }

  var watched = false;
  function watch(host) {
    if (watched || !host || !host.shadowRoot) return;
    watched = true;
    // Opening/closing the form animates; re-measure once it has settled
    // too, so the final size is used even if no resize/transition event
    // gets delivered.
    var settle = null;
    new MutationObserver(function () {
      schedule();
      clearTimeout(settle);
      settle = setTimeout(schedule, 600);
    }).observe(host.shadowRoot, { subtree: true, childList: true, attributes: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      var embed = host.shadowRoot.querySelector('#app-embed');
      if (embed) ro.observe(embed);
    }
    host.shadowRoot.addEventListener('transitionend', schedule, true);
    host.shadowRoot.addEventListener('animationend', schedule, true);
    schedule();
  }

  // The app injects its host (and fills its shadow root) after load.
  function find() {
    var host = document.querySelector('shopify-forms-embed');
    if (host && host.shadowRoot && host.shadowRoot.querySelector('#app-embed')) { watch(host); return true; }
    return false;
  }
  if (!find()) {
    var bodyObserver = new MutationObserver(function () { if (find()) bodyObserver.disconnect(); });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    // Its shadow content can arrive without a light-DOM mutation: poll briefly.
    var tries = 0;
    var poll = setInterval(function () { if (find() || ++tries > 60) { clearInterval(poll); bodyObserver.disconnect(); } }, 500);
  }

  window.addEventListener('resize', schedule);
}

// Don't depend on load timing (e.g. the script running before <body> has
// been parsed): start once the document is ready.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ianPopupsInit);
} else {
  ianPopupsInit();
}
